<!--
 * @Author: dengyaxin dengyaxin@xiaokunkeji.com
 * @Date: 2023-12-07 11:42:24
 * @LastEditors: dengyaxin dengyaxin@xiaokunkeji.com
 * @LastEditTime: 2023-12-16 16:38:45
 * @FilePath: /web-shop/src/pages/record/day.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="_content">
    <section class="day-record">
      <!-- 背景图 -->
      <img class="bg" src="https://res.xiaokunkeji.cn/image/2023/12/14/e41a13db2d4b41f181bff1e5aa73a44e.png" alt="" srcset="" />
      <section class="page-content">
        <RecordList :dataList="dataList" :tabList="tabList" :isDay="true">
          <template #top> {{ queryDateText }} </template>
          <template #tips="{ obj }">
            <section class="bottom" v-if="obj.noRevoke">
              <div class="left">
                <div class="tip">备注：核销1小时内可以撤销核销</div>
              </div>
              <div class="right" @click="revoke(obj)">
                <div class="return">撤销核销</div>
              </div>
            </section>
          </template>
        </RecordList>
      </section>
      <van-dialog v-model="isShow" class="dialog" title="撤销当前核销？" showCancelButton confirmButtonText='确认撤销'
        cancelButtonText='暂不撤销' get-container=".day-record" @confirm="sureRevoke">
        <div class="text">
          请和消费者确认后再进行撤销操作，撤销后该订单将不计入核销订单和核销收入。
        </div>
      </van-dialog>
    </section>
  </div>
</template>

<script>
import RecordList from "./components/list.vue";
import config from '@/configs/config';
import moment from 'moment';
export default {
  components: { RecordList },
  data() {
    return {
      dataList: [],
      tabList: {
        verifyOrderSum: {
          num: 0,
          text: "核销订单数",
          icon: 'https://res.xiaokunkeji.cn/image/2023/12/14/50fa1f29610e4cfaa9074e811fcd18e9.png',
        },
        orderAmountSum: {
          num: 0,
          text: "核销订单总收入",
          icon: 'https://res.xiaokunkeji.cn/image/2023/12/14/4360a3f7855d4483bcd3d25d3e4060e2.png',
        },
      },
      queryDate: "",//查询天
      isShow: false,//撤销弹窗
      time:null,//定时器
      revokeInfo:{},//撤销数据
      flag:true,//撤销按钮锁
      queryDateText:'',
    };
  },
  mounted() {
    this.queryDate = tuhu.getParam("date");
    this.queryDateText=moment(this.queryDate).format("YYYY年MM月DD日")
    this.shopId=tuhu.getParam("shopId")||JSON.parse(localStorage.getItem("_xk_user_key"))['shopId']
    this.queryDataList()
  },
  beforeDestroy() {
    clearInterval(this.time);
  },
  methods: {
    revoke(row) {
      this.isShow = true
      this.revokeInfo=row
    },
    //核销后59分钟内展示撤销按钮
    handleRevokeShow() {
      let _this=this
      this.time=setInterval(function () {
        let nowTime = Math.floor((new Date().getTime()) / (1000 * 60))
        _this.dataList=_this.dataList.map(item => {
        let writeOffTime = Math.floor((new Date(item.date).getTime()) / (1000 * 60))
          if(item.orderStatus==='CANCEL') {
            item.noRevoke=false
          }else{
            item.noRevoke=Math.floor(nowTime - writeOffTime) >= 60 ? false : true;//发测试调整60
          }
          return item
        });
      });
    },
    //获取列表数据
    async queryDataList() {
      tuhu.showIndicator()
      this.dataList=[]
      const res = await tuhu.fetch(`${config.apis.GET_TIKTOK_ORDER_DAY_RECORD}?shopId=${this.shopId}&date=${this.queryDate}`);
      tuhu.hideIndicator();
      if (res && res.code === '200') {
        this.tabList['verifyOrderSum']['num']=(res['data']&&res['data']['verifyOrderSum'])||0
        this.tabList['orderAmountSum']['num']=(res['data']&&res['data']['orderAmountSum'])||0
        this.dataList=res&&res.data&&res.data.orders.length?res.data.orders.map(item=>{
          item.date=item.createTime
          item.price = item.orderAmount
          item.title=item.orderTitle
          item.statusText=''
          if(item.orderStatus==='ORDER_FINISH') {
            item.statusText='核销成功'
          }
          if(item.orderStatus==='CANCEL') {
            item.statusText='已撤销核销'
          }
          return item
        }):[]
        if(this.dataList.length)this.handleRevokeShow()
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    //撤销核销接口
    async sureRevoke() {
      if(!this.flag)return
      this.flag=false
      const {providerOrderId,index} =this.revokeInfo
      const res = await tuhu.fetch(`${config.apis.QUERY_TIKTOK_CANCEL}`,{
        method: 'post',
        body: JSON.stringify({providerOrderId:providerOrderId})
      });
      this.flag=true
      if (res && res.code === '200') {
        // this.dataList[index]['orderStatus']='CANCEL'
        // this.dataList[index]['statusText']='已撤销核销'
        this.queryDataList()
        this.isShow = false
      }else {
        tuhu.toast(res.message || "网络错误");
      }
    }
  }
};
</script>
<style lang="less" scoped>
._content {
  background: #f8f9fb !important;

  .day-record {
    .bg {
      width: 100%;
      height: 14.85rem;
    }
    .page-content{
      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.4rem;
        .tip{
          font-size: 0.6rem;
          color: #C6C6C6;
          line-height: 0.7rem;
        }
        .return{
          width: 3.4rem;
          height: 1.2rem;
          background: #F5F5F5;
          border-radius: 1rem;
          color: #808080;
          text-align: center;
          line-height: 1.2rem;
          font-size: 0.6rem;
        }
      }

    }

    .dialog {
      .text {
        width: 13.75rem;
        margin: 1.2rem auto;
        height: 2.2rem;
        font-size: 0.7rem;
        color: #333333;
        line-height: 1.1rem;
      }

      :deep(.van-button::before) {
        background-color: transparent;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/record/day.vue